<template>
  <v-dialog max-width="500" v-model="localValue" @input="closeDialog">
    <v-card class="px-8 pt-4 pb-12" color="gray10">
      <v-btn icon @click="closeDialog" class="position-absolute modal-close">
        <v-icon clr="var(--v-gray2-base)">$modalClose</v-icon>
      </v-btn>
      <v-col class="text-center">
        <div class="font-Medium-16 gray1--text">
          {{ $t("accountPage.security.modals.removeGoogleAuth.title") }}
        </div>
      </v-col>

      <v-row class="mt-2">
        <v-col class="py-0 pe-0" cols="2" md="1">
          <v-icon size="22" clr="var(--v-warning-base)">$warningWallet</v-icon>
        </v-col>
        <v-col class="py-0 ps-0">
          <span class="font-Regular-12 warning--text">
            {{ $t("accountPage.security.modals.removeGoogleAuth.warning") }}
          </span>
        </v-col>
      </v-row>

      <template v-if="step === 1">
        <otp-order @changeStep="otpComplete" :otpType="'remove_2fa'" />
      </template>

      <template v-if="step === 2">
        <div class="mt-5">
          <!-- <v-text-field
            :label="$t('accountPage.security.modals.removeGoogleAuth.otpCode')"
            type="text"
            filled
            background-color="var(--v-field-base)"
            class="custom-form-control gray1--text login-form-control"
            v-model="otpCode"
            hide-details
          >
            <template v-slot:append>
             
              <v-btn
                color="primary"
                outlined
                small
                class="py-4"
                style="margin-top: -7px"
                :disabled="showCounter"
                :loading="otpLoading"
                @click="getOtp()"
              >
                <CountdownTimer
                  v-if="showCounter"
                  @countdown-finished="showCounter = false"
                  :targetTime="expireTime"
                />
                <span v-else>{{
                  $t("accountPage.security.modals.getCode")
                }}</span>
              </v-btn>
            </template>
          </v-text-field> -->
          <v-text-field
            v-model="password"
            :label="$t('accountPage.security.modals.password')"
            type="password"
            filled
            background-color="var(--v-field-base)"
            class="custom-form-control gray1--text login-form-control mt-5"
            hide-details
          >
          </v-text-field>
          <!-- <v-text-field
          v-model="google2fa"
          :label="$t('accountPage.security.modals.googleAuth')"
          type="text"
          filled
          background-color="var(--v-field-base)"
          class="custom-form-control gray1--text login-form-control mt-5"
          hide-details
        >
        </v-text-field> -->
        </div>

        <v-btn
          color="primary"
          block
          class="mt-8"
          x-large
          :loading="confirmLoading"
          @click="confirm"
        >
          {{ $t("accountPage.security.modals.confirm") }}
        </v-btn>
      </template>
    </v-card>
  </v-dialog>
</template>

<script>
import * as types from "@/store/types";
import { mapGetters } from "vuex";
import { SecurityService } from "@/services";
// import CountdownTimer from "@/components/Shared/CountdownTimer";
import OtpOrder from "@/components/Shared/OtpOrder/index";

export default {
  props: ["value"],
  components: { OtpOrder },
  data() {
    return {
      localValue: this.value,
      otpLoading: false,
      otpCode: null,
      password: null,
      google2fa: null,
      confirmLoading: false,
      expireTime: null,
      showCounter: false,
      step: 1
    };
  },
  computed: {
    ...mapGetters({
      userVerifyInfo: types.userVerifyInfo.getters.GET_USER_VERIFY_INFO
    })
  },
  watch: {
    value(newValue) {
      this.localValue = newValue;
    }
  },
  methods: {
    closeDialog() {
      this.localValue = false;
      this.$emit("input", false);
    },
    // getOtp() {
    //   this.otpLoading = true;
    //   SecurityService.getGoogleAuthOtp()
    //     .then((response) => {
    //       this.expireTime = parseFloat(response.data.data.expires_in);
    //       this.showCounter = true;
    //       // this.$toast.success(this.$t('accountPage.security.modals.codeSent'));
    //     })
    //     .finally(() => {
    //       this.otpLoading = false;
    //     });
    // },
    otpComplete() {
      console.log("otp was completed");
      this.step = 2;
    },
    confirm() {
      this.confirmLoading = true;
      SecurityService.removeGoogleAuth({
        // otp_code: this.otpCode,
        password: this.password
      })
        .then(response => {
          this.$toast.success(response.data.message);
          this.closeDialog();
          this.$router.go(0);
        })
        .finally(() => {
          this.confirmLoading = false;
        });
    }
  }
};
</script>
